'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/round.js
// module id = 1545
// module chunks = 8